import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPestIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.27727 14.8782V8.52174H10H11.7227V14.8782C11.4788 15.071 11.1841 15.276 10.8734 15.4362C10.5006 15.6284 10.2045 15.7043 10 15.7043C9.79549 15.7043 9.49937 15.6284 9.12659 15.4362C8.81594 15.276 8.52116 15.071 8.27727 14.8782ZM13.4455 8.52174C13.4455 7.53003 12.6742 6.72609 11.7227 6.72609C11.7227 6.56528 11.7024 6.4094 11.6644 6.26109L14.0546 3.76972L12.8364 2.5L10.4463 4.99129C10.304 4.9516 10.1544 4.93044 10 4.93044C9.84568 4.93044 9.6961 4.95159 9.55378 4.99126L7.16368 2.5L5.94553 3.76972L8.33562 6.26098C8.29756 6.40932 8.27727 6.56524 8.27727 6.72609C7.32583 6.72609 6.55454 7.53003 6.55454 8.52174V9.41964H5.1886L3.71815 7.88695L2.5 9.15667L4.47502 11.2153H6.55454V13.0109H4.47502L2.5 15.0695L3.71815 16.3392L5.1886 14.8065H6.55454V14.9606C6.55454 15.4368 6.73435 15.8966 7.09231 16.1926C7.73547 16.7243 8.86773 17.5 10 17.5C11.1323 17.5 12.2645 16.7243 12.9077 16.1926C13.2656 15.8966 13.4455 15.4368 13.4455 14.9606V14.8065H14.8114L16.2818 16.3392L17.5 15.0695L15.525 13.0109H13.4455V11.2153H15.525L17.5 9.15667L16.2818 7.88695L14.8114 9.41964H13.4455V8.52174Z",
		fill: "#0071CD"
	})
});
export default SvgPestIcon;
